import React, { useContext, useEffect, useRef, useState } from 'react'
import './OtpModal.css'
import AuthButton from '../Buttons/Buttons';
import UserContext from '../ContextApi/UserContext';
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import { URLS } from '../../Utils/app_urls';
import { errorPopup, successPopup } from '../../Utils/ToasterMessage';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const PASSCODE_LENGTH = 12;

export default function LoginOtpModal({ auth, userDetails }) {
    const { loginOtpModal, setLoginOtpModal } = useContext(UserContext)
    const navigate = useNavigate()
    const [digits, setDigits] = useState(Array(PASSCODE_LENGTH).fill(''))
    const [resentTime, setResentTime] = useState(30)
    const [disabledResendBtn, setDisabledResendBtn] = useState(false)
    const [loginAuth, setLoginAuth] = useState({})
    const [loader, setLoader] = useState(false)
    const inputRefs = useRef([])

    const  OTP = digits.join('')
    const isComplete = OTP.length === PASSCODE_LENGTH && digits.every(d => d !== '')

    useEffect(() => { setLoginAuth(auth) }, [auth])

    useEffect(() => {
        if (loginOtpModal) {
            setDigits(Array(PASSCODE_LENGTH).fill(''))
            setTimeout(() => inputRefs.current[0]?.focus(), 100)
        }
    }, [loginOtpModal])

    const handleChange = (index, value) => {
        if (!/^[a-zA-Z0-9]*$/.test(value)) return
        const newDigits = [...digits]
        if (value.length > 1) {
            const pasted = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, PASSCODE_LENGTH - index)
            pasted.split('').forEach((char, i) => {
                if (index + i < PASSCODE_LENGTH) newDigits[index + i] = char.toUpperCase()
            })
            setDigits(newDigits)
            const nextIdx = Math.min(index + pasted.length, PASSCODE_LENGTH - 1)
            inputRefs.current[nextIdx]?.focus()
            return
        }
        newDigits[index] = value.toUpperCase()
        setDigits(newDigits)
        if (value && index < PASSCODE_LENGTH - 1) inputRefs.current[index + 1]?.focus()
    }

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            if (digits[index]) {
                const newDigits = [...digits]
                newDigits[index] = ''
                setDigits(newDigits)
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus()
            }
        }
        if (e.key === 'ArrowLeft' && index > 0) inputRefs.current[index - 1]?.focus()
        if (e.key === 'ArrowRight' && index < PASSCODE_LENGTH - 1) inputRefs.current[index + 1]?.focus()
    }

    const handleResentOtp = () => {
        handleResendOtp()
        setDisabledResendBtn(true)
        let timesRun = 30
        let interval = setInterval(function () {
            timesRun -= 1
            setResentTime(timesRun)
            if (timesRun === 0) {
                clearInterval(interval)
                setDisabledResendBtn(false)
            }
        }, 1000)
    }

    const handleResendOtp = async () => {
        setLoader(true)
        await axios.post(URLS.login, userDetails)
            .then(res => {
                successPopup(res?.data?.message)
                setLoginAuth(res?.data?.data)
            })
            .catch(err => {
                errorPopup(err?.response?.data?.message)
                setLoader(true)
            })
    }

    const handleSubmit = () => {
        setLoader(true)
        axios.post(URLS.twoFactAuth, {
            "iv": loginAuth.iv,
            "content": loginAuth.content,
            "passcode": OTP
        })
            .then(res => {
                successPopup(res?.data?.message)
                setLoginOtpModal(false)
                setLoader(false)
                navigateToHomePage()
                localStorage.setItem('acessToken', res?.data?.data?.tokens?.access?.token)
            })
            .catch((err) => {
                errorPopup(err?.response?.data?.message)
                setLoader(false)
            })
    }

    const navigateToHomePage = () => {
        const interval = setTimeout(() => {
            navigate('/home')
        }, 1000)
        return () => clearTimeout(interval)
    }

    return (
        <div className={`${loginOtpModal ? 'd-block' : 'd-none'}`}>
            <div className="loginOtpModal">
                <div className="otp_container">
                    <div className='m-0 closeModal' onClick={() => setLoginOtpModal(false)}>
                        <IoClose />
                    </div>
                    <h1 className='text-center mb-4'>Enter Passcode to Verify</h1>
                    <div className='otp-input-box mb-4'>
                        <div>
                            {digits.map((digit, index) => (
                                <input
                                    key={index}
                                    ref={el => inputRefs.current[index] = el}
                                    type="text"
                                    inputMode="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={e => handleChange(index, e.target.value)}
                                    onKeyDown={e => handleKeyDown(index, e)}
                                    onPaste={e => {
                                        e.preventDefault()
                                        handleChange(index, e.clipboardData.getData('text'))
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                    {/* <p className='otpreset mt-2'>
                        Not received the Passcode?{' '}
                        <button disabled={disabledResendBtn} onClick={handleResentOtp}><span className='resendbtn'>Resend</span></button>
                    </p>
                    <p className='text-center'>
                        {(resentTime < 30 && resentTime > 0) && `OTP Resend after ${resentTime} seconds`}
                    </p> */}
                    <AuthButton disabled={loader || !isComplete} style={{ width: '90%' }} onClick={handleSubmit}>
                        {loader && <Spinner animation="border" />}
                        Submit
                    </AuthButton>
                </div>
            </div>
        </div>
    )
}